<template>
    <div class="treeDiv" v-loading="loading" :id="treeId">
        <el-header height="10px" class="tree-header"></el-header>
        <div class="inputDiv">
            <td-input v-show="inputShow" class="conshow" :width="inputWidth" :placeholder="$t(inputName)" v-model="filterText"></td-input>
        </div>
        <div>
            <td-checkbox style="margin-left:10px;" v-show="currentInvertBoxShow" @change="invertSelect">{{ $t('common.INVERT_SELECT') }}</td-checkbox>
        </div>
        <div class="conshow test-1" v-loading="treeLoading" :id="uuid" @scroll="treedataListScroll($event)" :style="'height:' + Number(treeHeight) + 'px;'">
            <el-tree
                v-if="!lazyloading"
                :allow-drag="allowDrag"
                :allow-drop="allowDrop"
                :default-expanded-keys="defaultKey"
                :default-expand-all="expandAll"
                :expand-on-click-node="expandOnClick"
                :check-strictly="currentCheckStrictly"
                :default-checked-keys="checkNodes"
                :data="treeList"
                :highlight-current="highlightCurrent"
                :empty-text="$t(emptyText)"
                :draggable="draggable"
                @node-click="onClick"
                @node-drag-end="nodeDragEnd"
                @node-drop="nodeDrop"
                @check="check"
                @check-change="checkChange"
                @node-contextmenu="onRightClick"
                @dblclick.native="onDbClick"
                @getCurrentNode="getCurrentNode"
                ref="tdTree"
                :accordion="accordion"
                :node-key="nodeKey"
                :props="defaultProps"
                :show-checkbox="showBox"
                :filter-node-method="filterNode"
                :render-content="renderContent"
            >
            </el-tree>
            <el-tree
                v-if="lazyloading"
                :allow-drag="allowDrag"
                :allow-drop="allowDrop"
                @getCurrentNode="getCurrentNode"
                :default-expanded-keys="defaultKey"
                :expand-on-click-node="expandOnClick"
                :check-strictly="currentCheckStrictly"
                :default-checked-keys="checkNodes"
                :highlight-current="highlightCurrent"
                @node-expand="expandNode"
                @check="check"
                :empty-text="$t(emptyText)"
                @node-drag-end="nodeDragEnd"
                @node-drop="nodeDrop"
                @node-collapse="collapse"
                @node-click="onClick"
                @check-change="checkChange"
                @node-contextmenu="onRightClick"
                :data="lazyTreeData"
                @dblclick.native="onDbClick"
                ref="tdTree"
                :node-key="nodeKey"
                :props="defaultProps"
                :show-checkbox="showBox"
                :draggable="draggable"
                :filter-node-method="filterNode"
                :render-content="renderContent"
                :accordion="true"
            >
            </el-tree>
        </div>
        <div v-show="menuVisible" tabindex="1" :id="menuId" ref="menu" @blur="menuBlur" :style="'width:' + menuWidth + 'px;' + 'background-color:white;'">
            <ul>
                <li class="menu__item" :style="'height:' + menuHeight + 'px;'" v-for="item in menuOptions" :key="item" @click="rightClick(item.value)">
                    {{ item.label }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        //树形是否默认选中第一个
        firstChecked: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树形懒加载时显示默认数据
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 树形是否懒加载
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否开启节点可拖拽
        draggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //高亮显示当前节点
        highlightCurrent: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否显示树形节点图标
        imgloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 无数据是默认显示文字 */
        emptyText: {
            type: String,
            default: 'common.NO_DATA'
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'label',
                    id: 'id',
                    imgName: 'imgName',
                    parentId: 'parentId'
                };
            }
        },
        params: Object,
        // 树形所在div高度
        height: {
            type: Number
        },
        // 树形搜索框宽度
        inputWidth: {
            type: Number,
            default: function() {
                return 200;
            }
        },
        // 树形节点id关键词
        nodeKey: {
            type: String,
            default: function() {
                return 'id';
            }
        },
        // 右键下拉菜单默认宽度
        menuWidth: {
            type: Number,
            default: function() {
                return 80;
            }
        },
        // 右键下拉菜单每个选项的高度
        menuHeight: {
            type: Number,
            default: function() {
                return 30;
            }
        },
        // 是否使用右键下拉菜单
        isRightMune: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 树形搜索框默认显示内容
        inputName: {
            type: String,
            default: function() {
                return 'component.PLEASE_ENTER_KEYWORD';
            }
        },
        // 反选框是否显示
        invertBoxShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否显示树形节点复选框
        showBox: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树节点自定义节点图标
        picturePath: {
            type: Object,
            default: function() {
                return {};
            }
        },
        // 是否使用组件内部方法获取树形数据
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 默认勾选树形节点id数组
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 右键下拉菜单显示内容
        showOptions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 默认展开树节点id数组
        defaultKey: {
            type: Array,
            default: function() {
                return ['21dsec1d-4a27-48d1-we4c5-e44fcc23110']; // 默认展开组织区域
            }
        },
        // 树形节点单击事件
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树形节点双击事件
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 节点是否只允许同级拖拽
        dragLevel: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        allowDrag: Function,
        notAllowDrop: Boolean,
        // 是否使用右击事件
        isRightClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 点击树形节点是否会展开或者收缩节点
        expandOnClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否每次只打开一个同级树节点展开 */
        accordion: Boolean,
        // 树形节点复选框是否单选
        isSingleCheck: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否取消父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 懒加载全部展开
        expandAll: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 图片前置路径
        previewImageUrl: {
            type: String,
            default: function() {
                return '';
            }
        },
        // 接口地址
        interfaceName: {
            type: Object,
            default: function() {
                return {
                    query: '', //树形接口
                    search: '' //搜索树接口
                };
            }
        },
        // 是否分布式部署
        isDistributed: {
            type: Boolean,
            default: false
        },
        /* 每页加载条数 */
        pageSize: {
            type: Number,
            default: 50
        },
        /* 默认保存页数 */
        savePageNum: {
            type: Number,
            default: 2
        },
        /* 转发请求接口路径 */
        treeForwardUrl: {
            type: String,
            default: '/systemManager/findTreeByUrl'
        },
        /* 获取自定义属性 */
        customProp: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 过滤不需要的节点
        filter: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 是否为过滤节点类型
        isFilter: {
            type: Boolean,
            default: false
        },
        token: {
            type: String
        },
        //是否级联搜索
        isUnionSearch: {
            type: Boolean,
            default: true
        },
        //是否扩展化展示
        isExtendedShow: {
            type: Boolean,
            default: false
        },
        //获取扩展信息接口
        fetchExtentionInfos: {
            type: Function,
            default: (extendInfos, datas) => {
                //模拟获取扩展信息，外层组件需要重新实现
                datas.map(data => {
                    let extendInfo = null;
                    if (data.typeId == '') {
                        extendInfo = {
                            status: Math.floor(Math.random() * 3)
                        };
                    } else {
                        extendInfo = {
                            status: 4,
                            count: 0
                        };
                    }
                    extendInfos[data.id] = extendInfo;
                });
            }
        },
        //扩展数据节点展开事件
        expandInfosExtend: {
            type: Function,
            default: (extendInfos, parent_id, children_ids) => {
                let count = children_ids.filter(id => extendInfos[id].status == 2).length;
                extendInfos[parent_id].count = count;
            }
        },
        //扩展数据内容显示
        contentExtend: {
            type: Function,
            default: (extendInfos, id) => {
                let count = extendInfos[id].count;
                return count == undefined ? '' : '(' + count + ')';
            }
        },
        //扩展数据样式显示
        styleExtend: {
            type: Function,
            default: (extendInfos, id) => {
                let status = extendInfos[id].status,
                    statusColors = ['#67C23A', '#E6A23C', '#F56C6C', '#909399'];
                return 'color:' + statusColors[status] + ';';
            }
        }
    },
    data() {
        return {
            /* 组件的随机id */
            uuid: 'tdtreeId' + this.getUUID(),
            treeId: this.getUUID(),
            currentInvertBoxShow: this.invertBoxShow,
            /* 父子关联属性 */
            currentCheckStrictly: this.checkStrictly,
            currentPage: 1,
            /* 懒加载数据对象 */
            lazyTreeData: [],
            /* 加载动画 */
            loading: false,
            /** 树形加载动画 */
            treeLoading: false,
            /* 点击展开的节点数据对象 */
            expandQueryMap: new Map(),
            /* 存储展开的div对象 */
            expandDivMap: new Map(),
            /* 展开的节点对象 */
            treeNode: '',
            /* 展开的节点数据 */
            treeData: '',
            /* 选中的节点id集合。key:父节点id，value：选中子节点 */
            selectKeysMap: new Map(),
            /* 存储当前节点以及子节点数据 */
            allNodeMap: new Map(),
            /* 存储当前节点以及子节点id数组 */
            allNodeIdList: [],
            /* 数据是否为分页加载数据,用于区分是否展开节点操作 */
            isLoadData: false,
            /* 搜索内容 */
            filterText: '',
            /* 数据是否为搜索数据 */
            isFilterdata: false,
            /*  右键节点对象 */
            rightData: '',
            /* 菜单Id */
            menuId: this.getUUID(),
            /* 右键菜单信息 */
            menuOptions: '',
            /* 控制右键下拉菜单是否显示*/
            menuVisible: false,
            /* 上一次的滚动条的位置 */
            scrollPosition: 0,
            /* 记录节点的分页信息 */
            currentPageMap: new Map(),
            /* 控制滚动加载重复请求数据 */
            isDataReturn: true,
            /* 存储分页请求数据小于pageSize信息，防止没有更多数据时一直请求后台接口 */
            pageSizeControlMap: new Map(),
            /* 记录节点的上传滚动方向 */
            isDownwardLoadingMap: new Map(),
            /* 处理初始化树形获取数据 */
            isIniTree: false,
            /* 默认选中的node节点数组 */
            checkNodeList: [],
            /* 当前节点未选中的节点集合 */
            treeDataNocheckMap: new Map(),
            /* 第一次进来的时候默认选中第一个节点 */
            firstNodeFlag: true,
            /* 是否正在搜索 */
            isSearch: false,
            extendInfos: {},
            /* 树形高度 */
            treeHeight: Number
        };
    },
    watch: {
        height: function(val) {
            this.treeHeight = val;
        }
    },
    created() {
        this.$watch(
            'filterText',
            this.$util.delayExcute(newQuery => {
                // 输入结束后，延时0.5秒执行查询
                if (this.lazyloading) {
                    this.treeLoading = true;
                    this.lazyTreeData = [];
                    this.initMapData();
                    if (this.filterText) {
                        this.currentPage = 1;
                        this.requestdata();
                        this.isSearch = true;
                    } else {
                        this.isSearch = false;
                        this.initTree();
                        //清空搜索树选择节点
                        if (!this.isUnionSearch) {
                            this.selectKeysMap.clear();
                            if (this.checkNodeList && this.checkNodeList.length > 0) {
                                this.checkNodeList.splice(0, this.checkNodeList.length);
                            }
                            this.$refs.tdTree.setCheckedKeys([]);
                        }
                    }
                } else {
                    this.$refs.tdTree.filter(this.filterText);
                }
            }, 500)
        );
    },
    mounted() {
        let startCalculation = false;
        let bottom = (window.tdTableBottom ? window.tdTableBottom : 0) + 15;
        let domNode = document.getElementById(this.uuid).parentNode.children;
        for (let i = 0; i < domNode.length; i++) {
            if (startCalculation) {
                bottom +=
                    domNode[i].clientHeight +
                    parseInt(window.getComputedStyle(domNode[i], null)['marginTop'].split('px')[0]) +
                    parseInt(window.getComputedStyle(domNode[i], null)['paddingTop'].split('px')[0]);
            }
            if (domNode[i].id.indexOf('tdtreeId') >= 0) {
                startCalculation = true;
            }
        }
        let inputHeight = 0;
        if (this.height === '' || this.height === 0 || this.height === undefined) {
            this.treeHeight = window.innerHeight - document.getElementById(this.uuid).getBoundingClientRect().top - inputHeight - bottom;
        } else {
            this.treeHeight = this.height;
        }
        /* 懒加载不支持反选功能 */
        if (this.lazyloading) {
            this.currentInvertBoxShow = false;
        }
        /* 单选时，父子默认不关联 */
        if (this.isSingleCheck) {
            this.currentCheckStrictly = true;
        }
        /* 页面初始化加载数据 */
        if (this.lazyloading) {
            this.lazyTreeData = [];
            this.initTree();
        }
    },
    methods: {
        getCurrentNode() {
            return this.$refs.tdTree.getCurrentNode();
        },
        /* 整合请求参数 */
        getParams() {
            let params = {};
            if (!this.$util.isEmpty(this.params)) {
                params = this.$util.clone(this.params);
            }
            params.pageSize = this.pageSize;
            params.currentPage = this.currentPage;
            params.needPage = this.isPaging;
            return params;
        },
        /* 初始化存储信息 */
        initMapData() {
            this.expandQueryMap.clear();
            this.expandDivMap.clear();
            this.allNodeMap.clear();
            this.currentPageMap.clear();
            this.pageSizeControlMap.clear();
            this.isDownwardLoadingMap.clear();
        },
        /* 懒加载初始化树形 */
        initTree(isClearAll) {
            /* 非查询关键字 */
            this.lazyTreeData = [];
            this.isFilterdata = false;
            /** 重载树并需要完全清空树的数据时调用 */
            if (isClearAll) {
                this.clearTreeData();
            } else {
                this.initMapData();
            }
            let params = this.getParams();
            this.isIniTree = true;
            if (this.calInternal) {
                // 使用组件内部方法获取树形数据
                this.queryData(params);
            } else {
                this.$emit('queryData', params);
            }
        },
        /** 清空树数据的方法（后续有需要清属性的可以追加） */
        clearTreeData() {
            this.initMapData();
            this.selectKeysMap.clear();
        },
        /* 调用查询接口  */
        queryData(params) {
            this.$emit('beforeQuery');
            let item;
            // modify 2019/09/07 允许自定义查询参数
            this.$emit('customQueryParam', params, this.treeData, function(str) {
                item = str;
            });
            //如果不存在修改方法或者返回参数有误，则按照原有参数继续查询
            if (this.$util.isEmpty(item)) {
                item = params;
            }
            // ending----
            let queryUrl = '';
            if (this.isDistributed) {
                // 后台调用全路径接口进行转发获取数据
                queryUrl = this.treeForwardUrl;
                item.treeDataUrl = this.interfaceName.query;
            } else {
                if (this.interfaceName == null || this.interfaceName.query == '') {
                    this.$log.error("this.interfaceName.query == ''");
                    return;
                }
                queryUrl = this.interfaceName.query;
            }
            window.vue.$apiAxios.postRequestBody(
                queryUrl,
                JSON.stringify(item),
                response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (!this.$util.isEmpty(response.data.content)) {
                            /* 请求数据小于分页数量说明所有数据加载完毕，向下滚动不在请求接口 */
                            if (response.data.content.length > 0 && this.pageSize > response.data.content.length) {
                                this.pageSizeControlMap.set(item.parentId, item.currentPage);
                            } else if (response.data.content.length == 0) {
                                this.pageSizeControlMap.set(item.parentId, item.currentPage - 1);
                                /* 处理回显数据信息 */
                                if (this.$util.isEmpty(this.treeDataNocheckMap.get(item[this.defaultProps.id]))) {
                                    let node = this.$refs.tdTree.getNode(item[this.defaultProps.id] + 'placeholder');
                                    if (node != undefined && node != null) {
                                        node.setChecked(true);
                                        this.$refs.tdTree.remove(node);
                                    }
                                }
                            }
                            this.dealWithTreeData(response.data.content);
                        } else {
                            this.$log.error('tdTree/queryData/response.data.content-------is error', response.data.statusCode);
                        }
                    } else {
                        this.$log.error('tdTree/queryData---------staus is error', response.status);
                    }
                    this.isDataReturn = true;
                    this.loading = false;
                    this.treeLoading = false;
                    this.$emit('queryUrlResponse', response);
                },
                null,
                null,
                this.token
            );
        },
        /* 处理接口返回数据 */
        dealWithTreeData(treedataList) {
            if (this.isFilter) {
                for (let item in treedataList) {
                    // 过滤不需要的节点类型
                    for (let i = 0; i < this.filter.length; i++) {
                        if (treedataList[item][this.filter[i].field] === this.filter[i].value) {
                            treedataList[item].disabled = true;
                            break;
                        }
                    }
                }
            }
            // 处理扩展数据
            if (this.isExtendedShow) {
                this.fetchExtentionInfos(this.extendInfos, treedataList);
            }
            if (treedataList.length > 0) {
                this.formtTree(treedataList);
                /* 树形初始化执行逻辑 */
                if (this.isIniTree) {
                    this.lazyTreeData = treedataList;
                    this.isIniTree = false;
                    this.$nextTick(function() {
                        if (treedataList.length == this.pageSize) {
                            /* 用于没有根节点直接进行数据加载的情况 */
                            let data = {};
                            data[this.defaultProps.id] = '';
                            data[this.defaultProps.children] = treedataList;
                            this.currentPageMap.set(data[this.defaultProps.id], 2);
                            this.getDivObj(data, data[this.defaultProps.children]);
                        }
                    });
                    let checkKeysList = this.getSelectKeysList();
                    if (checkKeysList.length > 0) {
                        this.$refs.tdTree.setCheckedKeys(checkKeysList);
                    }
                    this.$emit('onDbClick', treedataList[0]);
                    // 懒加载展开一级节点
                    if (this.expandDivMap.size == 0) {
                        this.$nextTick(function() {
                            let node = this.$refs.tdTree.getNode(treedataList[0]);
                            this.expandNode(treedataList[0], node);
                        });
                    }
                    return;
                }
                // 数据是否为搜索数据
                if (this.isFilterdata) {
                    this.dealSearchData(treedataList);
                    return;
                }
                // 处理树形展开获取数据
                if (!this.isLoadData) {
                    this.dealExpandData(treedataList);
                } else {
                    // 数据是否为分页加载数据
                    this.dealPageData(treedataList);
                }
            }
        },
        /* 点击节点关闭 */
        collapse(data, node) {
            this.expandDivMap.delete(data);
            this.currentPageMap.delete(data[this.defaultProps.id]);
            this.expandQueryMap.delete(data);
            this.isDownwardLoadingMap.delete(data[this.defaultProps.id]);
            this.treeDataNocheckMap.delete(data[this.defaultProps.id]);
            this.clearDeleteExpandStatus(data[this.defaultProps.children]);
        },
        // 点击节点展开
        expandNode(data, node) {
            if (this.isSearch) {
                this.$emit('expandNode', data, node);
                return;
            }
            /* 处理同级节点数据 */
            if (this.lazyloading) {
                let _this = this;
                this.expandQueryMap.forEach((value, key) => {
                    if (key[_this.defaultProps.parentId] == data[_this.defaultProps.parentId]) {
                        _this.expandDivMap.delete(key);
                    }
                });
            }
            let expandQuery = this.expandQueryMap.get(data);
            if (this.lazyloading && !expandQuery) {
                /* 将展开的节点id存于map中 */
                this.expandQueryMap.set(data, true);
                this.currentPageMap.set(data[this.defaultProps.id], 2);
                data[this.defaultProps.children] = [];
                node.childNodes = [];
                this.treeData = data;
                this.treeNode = node;
                this.isLoadData = false;
                var params = this.getParams();
                /* 透传自定义属性 */
                for (let key in this.customProp) {
                    params[this.customProp[key]] = data[this.customProp[key]];
                }
                params.parentId = data[this.defaultProps.id];
                params.currentPage = 1;
                if (this.calInternal) {
                    this.queryData(params);
                } else {
                    this.$emit('queryData', params);
                }
            } else if (this.lazyloading && expandQuery) {
                if (data[this.defaultProps.children].length == 1 && data[this.defaultProps.children][0][this.defaultProps.id] == '') {
                    data[this.defaultProps.children] = [];
                    return;
                }
                this.getDivObj(data, data[this.defaultProps.children]);
            }
            this.$emit('expandNode', data, node);
        },
        /* 展开节点时的数据处理 */
        dealExpandData(treedataList) {
            if (this.firstNodeFlag && this.firstChecked && !this.$util.isEmpty(treedataList)) {
                this.$emit('onDbClick', treedataList[0]);
                this.firstNodeFlag = false;
            }
            this.treeData[this.defaultProps.children] = treedataList;
            let isAddCheck = this.echoData(treedataList);
            this.$nextTick(function() {
                this.getDivObj(this.treeData, treedataList);
                let placeholderCheck = this.$refs.tdTree.getNode(this.treeData[this.defaultProps.id] + 'placeholder');
                if (isAddCheck && placeholderCheck !== null) {
                    placeholderCheck.visible = false;
                }
                /* 处理选中的节点逻辑 */
                if (this.showBox) {
                    this.setSelectNode(treedataList);
                }
            });
            //扩展展开节点事件
            if (this.isExtendedShow) {
                this.expandInfosExtend(this.extendInfos, this.treeData.id, treedataList.map(data => data.id));
            }
        },
        echoData(treedataList) {
            /* 获取父节点是否默认选中 */
            let isAddCheck = false;
            let parentId = this.treeData[this.defaultProps.id];
            let checkKeysList = this.getSelectKeysList();
            if (!this.isSingleCheck && checkKeysList.length > 0 && !this.isContains(parentId, checkKeysList) && this.showBox) {
                let isDownwardLoading = this.isDownwardLoadingMap.get(parentId);
                /* 是否存在空白节点 */
                let isContain = false;
                for (let item of this.treeData[this.defaultProps.children]) {
                    if (item.id === parentId + 'placeholder') {
                        isContain = true;
                    }
                }
                if (isDownwardLoading || this.$util.isEmpty(isDownwardLoading)) {
                    /* 存储当前查询数据未选中子节点的数据 */
                    let keys = [];
                    for (let item of treedataList) {
                        let isContain = this.isContains(item[this.defaultProps.id], checkKeysList);
                        if (!isContain) {
                            keys.push(item[this.defaultProps.id]);
                        }
                    }
                    /* 处理map中存储未节点的数据信息 */
                    if (keys.length > 0) {
                        if (this.$util.isEmpty(this.treeDataNocheckMap.get(parentId))) {
                            this.treeDataNocheckMap.set(parentId, keys);
                        } else {
                            let noCheckList = this.treeDataNocheckMap.get(parentId);
                            noCheckList = noCheckList.concat(keys);
                            this.treeDataNocheckMap.set(parentId, noCheckList);
                        }
                    }
                    /* 正常加载页 且 子节点全部选中 */
                    if (treedataList.length === this.pageSize && keys.length == 0 && !isContain) {
                        isAddCheck = true;
                        this.treeData[this.defaultProps.children].push({ id: parentId + 'placeholder' });
                        /* 处理最后一页数据 */
                    } else if (treedataList.length < this.pageSize) {
                        if (keys.length == 0 && isContain && this.$util.isEmpty(this.treeDataNocheckMap.get(parentId))) {
                            for (let i = 0; i < this.treeData[this.defaultProps.children]; i++) {
                                if (this.treeData[i].id === parentId + 'placeholder') {
                                    this.treeData.splice(i, 1);
                                    i--;
                                }
                            }
                        }
                    }
                } else {
                    /* 处理向上滚动数据 */
                    let noCheckList = this.treeDataNocheckMap.get(parentId);
                    if (this.$util.isArray(noCheckList) && noCheckList.length > 0 && !isContain) {
                        isAddCheck = true;
                        this.treeData[this.defaultProps.children].push({ id: parentId + 'placeholder' });
                    }
                }
            }
            return isAddCheck;
        },
        /* 分页查询数据处理 */
        dealPageData(treedataList) {
            this.loadData(this.treeData, treedataList);
            let isAddCheck = this.echoData(treedataList);
            this.$nextTick(function() {
                this.getDivObj(this.treeData, treedataList);
                let placeholderCheck = this.$refs.tdTree.getNode(this.treeData[this.defaultProps.id] + 'placeholder');
                if (isAddCheck && placeholderCheck !== null) {
                    placeholderCheck.visible = false;
                }
                // 根据父节点复选框是否被选中来加载下级子节点复选框选中情况
                if (this.showBox) {
                    this.setSelectNode(treedataList);
                }
                let scroll = document.getElementById(this.uuid);
                let nodeParent = this.expandDivMap.get(this.treeData);
                scroll.scrollTop = nodeParent.offsetTop + nodeParent.scrollHeight / 3;
            });
        },
        /* 处理查询数据 */
        dealSearchData(treedataList) {
            let isDownwardLoading = this.isDownwardLoadingMap.get(this.filterText);
            // 清除重复数据
            for (let i = 0; i < this.lazyTreeData.length; i++) {
                for (let j = 0; j < treedataList.length; j++) {
                    if (treedataList[j][this.defaultProps.id] == this.lazyTreeData[i][this.defaultProps.id]) {
                        // 如果数据重复，则清除需要加载数据中的重复数据
                        treedataList.splice(j, 1);
                        j--;
                    }
                }
            }
            /* 添加上部数据 */
            if (!isDownwardLoading) {
                this.lazyTreeData = treedataList.concat(this.lazyTreeData);
                let size = this.pageSize;
                if (this.lazyTreeData.length % this.pageSize > 0) {
                    // 最后一页数据不满this.pageSize，则向上滚动删除最后一页加载数据
                    size = this.lazyTreeData.length - this.pageSize * this.savePageNum;
                }
                this.lazyTreeData.splice(this.pageSize * this.savePageNum, size);
                this.scrollPosition = 0;
            } else {
                /* 添加下部数据 */
                this.lazyTreeData = this.lazyTreeData.concat(treedataList);
                if (this.lazyTreeData.length - this.pageSize * this.savePageNum > 0) {
                    let item = this.lazyTreeData.splice(0, this.pageSize);
                    /* 将删除的节点的展开状态清空 */
                    this.clearDeleteExpandStatus(item);
                }
            }
            this.$nextTick(function() {
                let scroll = document.getElementById(this.uuid);
                let id = treedataList[0][this.defaultProps.id];
                let checkKeysList = this.getSelectKeysList();
                this.$refs.tdTree.setCheckedKeys(checkKeysList);
                if (document.getElementById(id) !== null && this.lazyTreeData.length > this.pageSize) {
                    let nodeParent = document.getElementById(id).parentNode.parentNode.parentNode;
                    scroll.scrollTop = nodeParent.offsetTop + nodeParent.scrollHeight / 3;
                }
                this.getDivObj(this.lazyTreeData, treedataList);
            });
        },
        /*  树形为非懒加载时，默认选中树形节点list为异步获取时，调用此方法*/
        defaultSelect(checkList) {
            if (!this.$util.isArray(checkList) && !this.showBox) {
                return;
            }
            if (!this.lazyloading) {
                if (this.currentCheckStrictly) {
                    this.$refs.tdTree.setCheckedKeys(checkList);
                } else {
                    this.setCheck(this.treeList, checkList);
                }
            } else {
                this.selectKeysMap.clear();
                this.selectKeysMap.set('currentCheckStrictly', checkList);
                this.$refs.tdTree.setCheckedKeys(checkList);
            }
        },
        /* 设置选中节点状态 */
        setSelectNode(treedataList) {
            /* 获取当前数组的父节点信息 */
            let treeNode = this.$refs.tdTree.getNode(this.treeData[this.defaultProps.id]);
            if (!this.isSingleCheck) {
                let keys = [];
                if (treeNode.checked && !this.currentCheckStrictly) {
                    for (let item in treedataList) {
                        /* 父节点选中则选中所有子节点 */
                        keys.push(treedataList[item][this.defaultProps.id]);
                        this.checkNodeList.push(treedataList[item]);
                    }
                }
                let checkKeysList = this.getSelectKeysList();
                checkKeysList = checkKeysList.concat(keys);
                this.$refs.tdTree.setCheckedKeys(checkKeysList);
                /* 将选中的节点同步到map当中 */
                if (keys.length > 0) {
                    this.setSelectKeysToMap(treedataList[0][this.defaultProps.parentId], keys);
                }
            } else {
                //单选情况下，回显
                let checkKeysList = this.getSelectKeysList();
                this.$refs.tdTree.setCheckedKeys(checkKeysList);
            }
        },
        /* 将选中的节点信息存储到selectCheckKeysMap中 */
        setSelectKeysToMap(parentId, checkKeysList) {
            let keys = [];
            keys = this.selectKeysMap.get(parentId);
            if (this.$util.isEmpty(keys)) {
                this.selectKeysMap.set(parentId, checkKeysList);
            } else {
                keys = keys.concat(checkKeysList);
                this.selectKeysMap.set(parentId, keys);
            }
        },
        /* 获取所有的选中节点的list数组 */
        getSelectKeysList() {
            let checkKeysList = [];
            let _this = this;
            this.selectKeysMap.forEach(function(value, key, map) {
                checkKeysList = checkKeysList.concat(_this.selectKeysMap.get(key));
            });
            return checkKeysList;
        },
        /* 当遵循父节点选中后子节点也相继选中，用于判断所传节点id中同时包含父子节点时，将父节点删除 */
        setCheck(treeDataList, checkKeysList) {
            this.getAllNode(treeDataList, false);
            let selectKeysList = [];
            for (let i in checkKeysList) {
                let data = this.allNodeMap.get(checkKeysList[i]);
                if (!this.$util.isEmpty(data)) {
                    if (this.isHasChild(data)) {
                        let include = false;
                        for (let l in checkKeysList) {
                            let id = checkKeysList[l];
                            for (let n in data[this.defaultProps.children]) {
                                let treeData = data[this.defaultProps.children][n];
                                if (treeData[this.defaultProps.id] === id) {
                                    include = true;
                                    break;
                                }
                            }
                        }
                        if (!include) {
                            selectKeysList.push(checkKeysList[i]);
                        }
                    } else {
                        selectKeysList.push(checkKeysList[i]);
                    }
                }
            }
            this.$refs.tdTree.setCheckedKeys(selectKeysList);
        },
        /* 处理树形节点数据*/
        loadData(data, treedataList) {
            if (!this.$util.isEmpty(treedataList) && this.filterText === '') {
                let isDownwardLoading = this.isDownwardLoadingMap.get(data[this.defaultProps.id]);
                // 清除重复数据，解决拖拽数据重复
                for (let i = 0; i < data[this.defaultProps.children].length; i++) {
                    for (let j = 0; j < treedataList.length; j++) {
                        if (treedataList[j][this.defaultProps.id] == data[this.defaultProps.children][i][this.defaultProps.id]) {
                            // 如果数据重复，则清除需要加载重复数据
                            treedataList.splice(j, 1);
                            j--;
                        }
                    }
                }
                let placeholderNode = this.$refs.tdTree.getNode(data[this.defaultProps.id] + 'placeholder');
                let placeholderNum = 0;
                /* 空白节点占位 */
                if (placeholderNode !== null) {
                    placeholderNum++;
                }
                /* 添加上部数据 */
                if (!isDownwardLoading) {
                    data[this.defaultProps.children] = treedataList.concat(data[this.defaultProps.children]);
                    let size = this.pageSize;
                    if ((data[this.defaultProps.children].length % this.pageSize) - placeholderNum > 0) {
                        // 最后一页数据不满this.pageSize，则向上滚动删除最后一页加载数据
                        size = data[this.defaultProps.children].length - this.pageSize * this.savePageNum + placeholderNum;
                    }
                    let item = data[this.defaultProps.children].splice(this.pageSize * this.savePageNum, size);
                    /* 将删除的节点的展开状态清空 */
                    this.clearDeleteExpandStatus(item);
                    this.scrollPosition = 0;
                } else {
                    /* 添加下部数据 */
                    data[this.defaultProps.children] = data[this.defaultProps.children].concat(treedataList);
                    if (data[this.defaultProps.children].length - (this.pageSize * this.savePageNum + placeholderNum) > 0) {
                        let item = data[this.defaultProps.children].splice(0, this.pageSize);
                        /* 将删除的节点的展开状态清空 */
                        this.clearDeleteExpandStatus(item);
                    }
                }
            }
        },
        /* 查询完毕删除多余数据时，将节点的展开状态删除，在下次展开时重新进行查询 */
        clearDeleteExpandStatus(treeList) {
            if (null != treeList && undefined != treeList) {
                for (let i = 0; i < treeList.length; i++) {
                    if (this.expandQueryMap.get(treeList[i]) !== undefined) {
                        this.expandQueryMap.delete(treeList[i]);
                        this.expandDivMap.delete(treeList[i]);
                        if (treeList[i][this.defaultProps.children].length > 0) {
                            /* 递归删除所有子节点的展开状态 */
                            this.clearDeleteExpandStatus(treeList[i][this.defaultProps.children]);
                        }
                    }
                }
            }
        },
        /* 搜索逻辑处理 */
        requestdata() {
            var params = this.getParams();
            params.caption = this.filterText;
            params.currentPage = this.currentPage;
            this.currentPageMap.set(this.filterText, 2);
            this.isFilterdata = true;
            if (this.calInternal) {
                this.querySearchData(params);
            } else {
                this.$emit('querySearchData', params);
            }
        },
        /* 搜索数据请求处理 */
        querySearchData: function(param) {
            // 调用搜索接口，处理搜索树形
            let interfaceName = this.treeForwardUrl;
            /* 分布式情况，通过请求固定url进行转发 */
            if (!this.isDistributed) {
                interfaceName = this.interfaceName.search;
            } else {
                param.treeDataUrl = this.interfaceName.search;
            }
            window.vue.$apiAxios.postRequestBody(
                interfaceName,
                JSON.stringify(param),
                response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                        if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                            /* 请求数据小于分页数量说明所有数据加载完毕，向下滚动不在请求接口 */
                            if (response.data.content.length > 0 && this.pageSize > response.data.content.length) {
                                this.pageSizeControlMap.set(param.caption, param.currentPage);
                            } else if (response.data.content.length == 0) {
                                this.pageSizeControlMap.set(param.caption, param.currentPage - 1);
                            }
                            this.dealWithTreeData(response.data.content);
                        } else {
                            this.$log.error('tdTree/querySearchData/response.data.content-------is error', response.data.statusCode);
                        }
                    } else {
                        this.$log.error(interfaceName, response.status);
                    }
                    this.loading = false;
                    this.treeLoading = false;
                    this.isDataReturn = true;
                },
                null,
                null,
                this.token
            );
        },
        /* 树形节点反选功能 */
        invertSelect() {
            let checkedList = [];
            this.getAllNode(this.treeList, true);
            let checkedKeys = this.getCheckedKeys();
            for (let i in this.allNodeIdList) {
                let dataId = this.allNodeIdList[i];
                let contains = this.isContains(dataId, checkedKeys);
                if (!contains) {
                    checkedList.push(dataId);
                }
            }
            if (!this.currentCheckStrictly) {
                let halfCheckedKeys = this.$refs.tdTree.getHalfCheckedKeys();
                for (let n = 0; n < checkedList.length; n++) {
                    let checkId = checkedList[n];
                    let contains = this.isContains(checkId, halfCheckedKeys);
                    if (contains) {
                        checkedList.splice(n, 1);
                        n = n - 1;
                    }
                }
            }
            this.$refs.tdTree.setCheckedKeys(checkedList);
        },
        // 赋予树形选中节点id数组
        // setSelectKeys(checkList) {
        //     this.defaultSelect(checkList);
        // },
        /* 节点是否只允许同级拖拽 */
        allowDrop(draggingNode, dropNode, type) {
            if (this.notAllowDrop) {
                return false;
            }
            if (this.dragLevel) {
                if (draggingNode.parent === dropNode.parent) {
                    return type !== 'inner';
                }
                return false;
            }
            return true;
        },
        /* 拖拽方法 */
        nodeDragEnd(dragNode, dropNode, dropType) {
            this.$emit('nodeDragEnd', dragNode, dropNode, dropType);
        },
        /* 拖拽方法 */
        nodeDrop(dragNode, dropNode, dropType) {
            if (dragNode.data[this.defaultProps.parentId] !== undefined) {
                if (dropType === 'inner') {
                    dragNode.data[this.defaultProps.parentId] = dropNode.data[this.defaultProps.id];
                } else {
                    dragNode.data[this.defaultProps.parentId] = dropNode.data[this.defaultProps.parentId];
                }
            }
            this.$emit('nodeDrop', dragNode, dropNode, dropType);
        },
        /* 监听滚动条变化 */
        treedataListScroll(event) {
            // 用于控制右键菜单隐藏
            if (this.menuVisible) {
                this.menuVisible = false;
            }
            if ((!this.lazyloading && !this.isPaging) || !this.isDataReturn) {
                return;
            }
            /*获取当前树形的div对象 */
            let tdTreeDiv = document.getElementById(this.uuid);
            /* div对象上滚动条高度 */
            let scrollHeight = tdTreeDiv.scrollTop;
            // （判断当前树形div顶部距离页面div距离）
            let scroll = document.getElementById(this.treeId);
            let scrollOffsetTop = scroll.offsetTop;
            for (let [data, nodeParent] of this.expandDivMap.entries()) {
                /* 存储数据关键字 */
                let keyWord = data[this.defaultProps.id];
                if (this.filterText !== '') {
                    keyWord = this.filterText;
                }
                if (!this.$util.isEmpty(data)) {
                    /* 当前节点的div对象相对可视区域的距离 */
                    let nodeDivTop = nodeParent.getBoundingClientRect().top;
                    let isDownwardLoading = this.isDownwardLoadingMap.get(keyWord);
                    if (this.$util.isEmpty(isDownwardLoading)) {
                        this.isDownwardLoadingMap.set(keyWord, true);
                    }
                    if (this.scrollPosition - scrollHeight >= 0) {
                        let distance = nodeDivTop - scrollOffsetTop;
                        /* 处理搜索框的高度值 */
                        if (this.inputShow) {
                            distance = distance - 42;
                        }
                        /* 加载上部数据 */
                        if (distance > 0) {
                            let loadPage = this.currentPageMap.get(keyWord);
                            let isDownwardLoading = this.isDownwardLoadingMap.get(keyWord);
                            if (isDownwardLoading && loadPage > 0) {
                                let pageSizeControl = this.pageSizeControlMap.get(keyWord);
                                /* 页数大于最大限制时，设为最大限制页数 */
                                if (!this.$util.isEmpty(pageSizeControl) && loadPage > pageSizeControl) {
                                    this.currentPageMap.set(keyWord, pageSizeControl - this.savePageNum);
                                } else {
                                    /* -1 因为map中保存的为下一次查询页数 */
                                    this.currentPageMap.set(keyWord, loadPage - this.savePageNum - 1);
                                }
                            }
                            this.isDownwardLoadingMap.set(keyWord, false);
                            if (this.currentPageMap.get(keyWord) <= 0) {
                                continue;
                            }
                            this.loading = true;
                            this.isDataReturn = false;
                            this.upload(data);
                            this.treeNode = nodeParent;
                            return;
                        }
                    } else {
                        // 内容可视化高度
                        let nodeScrollHeight = nodeParent.scrollHeight;
                        // div距body距离
                        let scrollHeights = nodeParent.offsetTop;
                        // 计算树形节点div底部距离树形div底部距离
                        // let distance = nodeScrollHeight + scrollHeights - scrollHeight - this.treeHeight - scrollOffsetTop;
                        let distance = nodeScrollHeight + scrollHeights - scrollHeight - this.treeHeight - nodeParent.offsetTop;
                        if (distance <= 1) {
                            /* 显示的数据数量 */
                            let treeDataLength = 0;
                            /* 搜索时以关键字为key值进行存储 */
                            if (this.filterText !== '') {
                                /* 搜索时存储的divMap的key为显示的数据数组 */
                                treeDataLength = data.length;
                            } else {
                                treeDataLength = data[this.defaultProps.children].length;
                            }
                            let uploadPages = this.currentPageMap.get(keyWord);
                            let isDownwardLoading = this.isDownwardLoadingMap.get(keyWord);
                            /* 改变滚动方向时，计算查询页码 */
                            if (!isDownwardLoading) {
                                /* currentPageMap保存为上部数据下一次查询的页吗 */
                                uploadPages = uploadPages + this.savePageNum + 1;
                            }
                            this.currentPageMap.set(keyWord, uploadPages);
                            /* 页码最大控制 */
                            let pageSizeControl = this.pageSizeControlMap.get(keyWord);
                            this.isDownwardLoadingMap.set(keyWord, true);
                            /* 如果请求页数超过最大限制则放弃请求接口 */
                            if (!this.$util.isEmpty(pageSizeControl) && pageSizeControl < uploadPages) {
                                continue;
                            }
                            /* 防止达到请求页数，并上下滚动时反复请求最大限制页数据问题 */
                            /* 解决添加数据导致滚动失效，树形不加载问题
                            if (treeDataLength > this.pageSize && uploadPages < this.savePageNum + 1) {
                                continue;
                            } */
                            this.isDataReturn = false;
                            this.loading = true;
                            this.upload(data);
                            this.treeNode = nodeParent;
                            return;
                        }
                    }
                }
            }
            /* 记录上次滚动的位置 */
            this.scrollPosition = scrollHeight;
        },
        // 分页获取树形节点数据
        upload(data) {
            this.treeData = data;
            this.isLoadData = true;
            /* 整合查询参数 */
            var params = this.getParams();
            let keyWord = data[this.defaultProps.id];
            if (this.filterText !== '') {
                keyWord = this.filterText;
                params.caption = this.filterText;
            } else {
                /* 透传自定义属性 */
                for (let key in this.customProp) {
                    params[this.customProp[key]] = data[this.customProp[key]];
                }
                params.parentId = data[this.defaultProps.id];
            }
            /* 处理分页逻辑 */
            let currentPage = this.currentPageMap.get(keyWord);
            params.currentPage = currentPage;
            let isDownwardLoading = this.isDownwardLoadingMap.get(keyWord);
            if (!isDownwardLoading) {
                currentPage--;
                this.currentPageMap.set(keyWord, currentPage);
            } else {
                currentPage++;
                this.currentPageMap.set(keyWord, currentPage);
            }
            /* 调用查询接口 */
            if (this.calInternal) {
                // 调用树形内部方法，获取树形数据
                if (this.filterText !== '') {
                    this.querySearchData(params);
                    return;
                }
                this.queryData(params);
            } else {
                // 使用自定义查询方法
                if (this.filterText !== '') {
                    this.$emit('querySearchData', params);
                    return;
                }
                this.$emit('queryData', params);
            }
        },
        /* 获取节点图标 */
        renderContent(createElement, c) {
            // 是否添加图标
            var hasImage = false;
            // 图标名称
            let imgName = c.data[this.defaultProps.imgName];
            // 图片路径
            let url = (this.previewImageUrl !== '' ? this.previewImageUrl : window.config.treeIcon) + '/' + this.$store.state.skin + '/img/tree/' + imgName;
            // 拼接样式
            let img;
            if (this.imgloading && !this.$util.isEmpty(imgName)) {
                // 子系统树形图片路径
                img = "padding: 2px 2px 0px 25px; background-image:url('" + url + "'); background-repeat:no-repeat;height:20px;";
                hasImage = true;
                // 样式扩展
                if (this.isExtendedShow) {
                    img += this.styleExtend(this.extendInfos, c.data.id);
                }
            }
            var customNode;
            var _this = this;
            let data = this.$util.clone(c.data);
            this.$emit('customNode', this.$util.clone(c.data), function(costomData, str) {
                if (!_this.$util.isEmpty(costomData)) {
                    data = costomData;
                }
                if (!_this.$util.isEmpty(str) && _this.$util.isArray(str)) {
                    customNode = createElement(
                        'span',
                        str.map(function(info) {
                            let bgImg = '';
                            if (_this.$util.isEmpty(info.isLocal)) {
                                bgImg =
                                    'url(' +
                                    (!_this.$util.isEmpty(_this.previewImageUrl) ? _this.previewImageUrl : window.config.treeIcon) +
                                    '/' +
                                    window.vue.$store.state.skin +
                                    '/img/tree/' +
                                    info.icon +
                                    ') ';
                            }
                            return createElement(
                                'el-tooltip',
                                {
                                    props: {
                                        content: info.toolTip,
                                        placement: 'top',
                                        effect: 'dark',
                                        disabled: info.toolTip ? false : true
                                    }
                                },
                                [
                                    createElement(
                                        info.type,
                                        {
                                            on: {
                                                click: () => {
                                                    _this.parentMethod(_this.$parent, info.method, data);
                                                }
                                            },
                                            props: {
                                                type: 'text',
                                                icon: info.icon
                                            },
                                            style: {
                                                'background-image': bgImg,
                                                'background-repeat': 'no-repeat',
                                                padding: '0px 0px 0px 5px',
                                                minWidth: '0px',
                                                fontSize: '16px',
                                                width: '22px',
                                                height: '22px'
                                            }
                                        },
                                        info.label
                                    )
                                ]
                            );
                        })
                    );
                }
            });
            return createElement(
                'span',
                {
                    class: hasImage ? 'custom-tree-node' : '',
                    style: hasImage ? img : {},
                    attrs: {
                        id: data[this.defaultProps.id]
                    }
                },
                [
                    <span class="span-ellipsis">
                        <span title={data[this.defaultProps.label]}>
                            {data[this.defaultProps.label]}
                            {this.isExtendedShow ? this.contentExtend(this.extendInfos, data[this.defaultProps.id]) : ''}
                        </span>
                    </span>,
                    customNode
                ]
            );
        },
        // 递归寻找父组件方法
        parentMethod(parent, method, event) {
            if (parent[method]) {
                parent[method](event);
            } else {
                return this.parentMethod(parent.$parent, method, event);
            }
        },
        // 树形节点右击事件
        onRightClick(event, data) {
            if (this.isRightClick) {
                if (this.isRightMune) {
                    if (data.rightMenuType != null && data.rightMenuType !== '' && data.rightMenuType !== undefined) {
                        for (let i in this.showOptions) {
                            let menuItem = this.showOptions[i];
                            if (menuItem.rightMenuType === data.rightMenuType) {
                                this.menuOptions = menuItem.rightMenuList;
                            }
                        }
                    } else {
                        this.menuOptions = this.showOptions;
                    }
                    this.rightData = data;
                    this.menuVisible = true;
                    let height = this.menuHeight * this.menuOptions.length;
                    let menuObj = document.getElementById(this.menuId);
                    menuObj.style.position = 'absolute';
                    /* 菜单定位基于鼠标点击位置 */
                    let nodeParent = document.getElementById(data[this.defaultProps.id]).parentNode.parentNode;
                    let scrollHeights = nodeParent.offsetTop;
                    if (scrollHeights + height > this.treeHeight) {
                        menuObj.style.top = event.clientY - height + 'px';
                    } else {
                        menuObj.style.top = event.clientY + 'px';
                    }
                    let treeWidth = document.getElementById(this.menuId).parentNode.offsetWidth;

                    if (event.clientX > treeWidth / 2) {
                        menuObj.style.left = event.clientX - this.menuWidth - 10 + 'px';
                    } else {
                        menuObj.style.left = event.clientX + 10 + 'px';
                    }
                    this.$nextTick(function() {
                        this.$refs.menu.focus();
                    });
                } else {
                    this.$emit('onRightClick', data);
                }
            }
        },
        // 右键菜单中选项单击操作事件
        rightClick(value) {
            this.menuVisible = false;
            this.$emit('onRightClick', this.rightData, value);
        },
        // 右键菜单失去焦点事件
        menuBlur() {
            this.menuVisible = false;
        },
        /*存放div对象  */
        getDivObj(data, treedataList) {
            if (this.isPaging && treedataList.length > 0) {
                let id = treedataList[0][this.defaultProps.id];
                this.$nextTick(function() {
                    if (document.getElementById(id) !== null && treedataList.length >= this.pageSize) {
                        // 获取点击树形节点加载div的对象
                        let nodeParent = document.getElementById(id).parentNode.parentNode.parentNode;
                        this.expandDivMap.set(data, nodeParent);
                    }
                });
            }
        },
        /*  判断传入id是否包含在传入list中*/
        isContains(dataId, checkedList) {
            let isContains = false;
            for (let i in checkedList) {
                if (checkedList[i] === dataId) {
                    isContains = true;
                }
            }
            return isContains;
        },
        /*  判断树形节点是否含有子节点 */
        isHasChild(data) {
            let isHasChild = false;
            if (data[this.defaultProps.children] !== null && data[this.defaultProps.children] !== '' && data[this.defaultProps.children] !== undefined && data[this.defaultProps.children].length > 0) {
                if (!this.$util.isEmpty(data[this.defaultProps.children][0][this.defaultProps.id])) {
                    isHasChild = true;
                }
            }
            return isHasChild;
        },
        // 节点过滤 通过关键字过滤树节点
        filterNode(value, data) {
            if (!value) {
                return true;
            }
            return data[this.defaultProps.label].indexOf(value) !== -1;
        },
        /*  获取当前树形节点*/
        getAllNode(treeDataList, isNodeId) {
            for (let i in treeDataList) {
                let data = treeDataList[i];
                if (isNodeId) {
                    this.allNodeIdList.push(data[this.defaultProps.id]);
                } else {
                    this.allNodeMap.set(data[this.defaultProps.id], data);
                }
                if (this.isHasChild(data)) {
                    this.getAllNode(data[this.defaultProps.children], isNodeId);
                }
            }
        },
        // 树形节点单击事件
        onClick(data) {
            this.clickData = data;
            if (this.isClick) {
                this.$emit('onClick', data);
            }
        },
        // 获取当前树形全选中节点id
        getCheckedKeys() {
            let checkedKeys = this.$refs.tdTree.getCheckedKeys();
            if (this.lazyloading) {
                checkedKeys = checkedKeys.concat(this.getSelectKeysList());
                let checkKey = [];
                for (let i in checkedKeys) {
                    let dataId = checkedKeys[i];
                    if (!this.$util.isEmpty(dataId) && checkKey.indexOf(dataId) < 0) {
                        checkKey.push(dataId);
                    }
                }
                return checkKey;
            } else {
                return checkedKeys;
            }
        },
        /* 外部查出数据后，通过此方法将数据传入到树形控件中 */
        initData(treedataList) {
            this.loading = false;
            this.isDataReturn = true;
            if (!this.$util.isEmpty(treedataList) && treedataList.length > 0) {
                this.dealWithTreeData(treedataList);
            }
            this.treeLoading = false;
        },
        // 获取当前树形半选中树形节点id数组
        getHalfCheckedKeys() {
            return this.$refs.tdTree.getHalfCheckedKeys();
        },
        // 获取当前树形半选中树形节点对象数组
        getHalfCheckedNodes() {
            return this.$refs.tdTree.getHalfCheckedNodes();
        },
        isContainsId(item, list) {
            let isContains = false;
            for (let i in list) {
                if (list[i][this.defaultProps.id] === item[this.defaultProps.id]) {
                    isContains = true;
                    break;
                }
            }
            return isContains;
        },
        /* 获取当前被选中树形节点对象信息 */
        getCheckedNodes() {
            let checkNodes = [];
            if (this.showBox && this.lazyloading) {
                let checkedNodes = this.$refs.tdTree.getCheckedNodes();
                checkedNodes = this.checkNodeList.concat(checkedNodes);
                for (let i in checkedNodes) {
                    let dataId = checkedNodes[i][this.defaultProps.id];
                    if (!this.$util.isEmpty(dataId) && !this.isContainsId(checkedNodes[i], checkNodes)) {
                        checkNodes.push(checkedNodes[i]);
                    }
                }
            } else if (!this.lazyloading) {
                checkNodes = this.$refs.tdTree.getCheckedNodes();
            }
            return checkNodes;
        },
        setCheckedNodes(checkList) {
            if (this.showBox && this.lazyloading) {
                this.checkNodeList = checkList;
                this.selectKeysMap.clear();
                let checkKeys = [];
                for (let i in checkList) {
                    if (this.currentCheckStrictly) {
                        checkKeys.push(checkList[i][this.defaultProps.id]);
                    } else {
                        let keys = this.selectKeysMap.get(checkList[i][this.defaultProps.parentId]);
                        if (this.$util.isEmpty(checkList[i][this.defaultProps.parentId])) {
                            continue;
                        }
                        if (this.$util.isEmpty(keys)) {
                            this.selectKeysMap.set(checkList[i][this.defaultProps.parentId], [checkList[i][this.defaultProps.id]]);
                        } else {
                            keys.push(checkList[i][this.defaultProps.id]);
                            this.selectKeysMap.set(checkList[i][this.defaultProps.parentId], keys);
                        }
                    }
                }
                /* 父子不关联的情况 */
                if (this.currentCheckStrictly) {
                    this.selectKeysMap.set('currentCheckStrictly', checkKeys);
                    let checkKeysList = this.getSelectKeysList();
                    this.$refs.tdTree.setCheckedKeys(checkKeysList);
                } else {
                    let checkKeysList = this.getSelectKeysList();
                    let checkedList = [];
                    checkKeysList.forEach(checkKey => {
                        let node = this.$refs.tdTree.getNode(checkKey);
                        this.checkChange(node, false);
                        if (node && node.childNodes && node.childNodes.length <= 1) {
                            checkedList.push(checkKey);
                        }
                    });
                    this.$refs.tdTree.setCheckedKeys(checkedList);
                }
            } else {
                this.$refs.tdTree.setCheckedNodes(checkList);
            }
        },
        /*  */
        getNode(val) {
            return this.$refs.tdTree.getNode(val);
        },
        // 树形节点双击事件
        onDbClick() {
            if (this.isDbClick) {
                this.$emit('onDbClick', this.clickData);
            }
            if (this.isDbClick && this.clickData != undefined) {
                this.$emit('onDbClickEx', this.clickData);
            }
        },
        // 当复选框被点击的时候触发
        check(data, treeObj) {
            let isCheck = this.$refs.tdTree.getNode(data).checked;
            let keyWord = data[this.defaultProps.id];
            if (this.lazyloading) {
                let parentId = '';
                let superiorParentId = '';
                if (this.currentCheckStrictly) {
                    parentId = 'currentCheckStrictly';
                } else {
                    parentId = data[this.defaultProps.parentId];
                    /* 适用于根节点的情况 */
                    if (this.$util.isEmpty(parentId)) {
                        parentId = keyWord;
                    }
                    /* 父节点的父节点id */
                    let parentNode = this.$refs.tdTree.getNode(parentId);
                    if (parentNode !== null) {
                        superiorParentId = parentNode.data[this.defaultProps.parentId];
                    }
                    if (this.$util.isEmpty(keyWord) || this.$util.isEmpty(parentId)) {
                        return;
                    }
                }
                /* 单选处理 */
                if (this.isSingleCheck) {
                    if (isCheck) {
                        this.selectKeysMap.clear();
                        this.selectKeysMap.set(parentId, [keyWord]);
                        this.checkNodeList = [keyWord];
                        this.$refs.tdTree.setCheckedKeys([keyWord]);
                    } else {
                        this.selectKeysMap.clear();
                        this.checkNodeList = [];
                    }
                    /* 回调父组件方法 */
                    this.$emit('check', data, treeObj);
                    return;
                }
                if (!isCheck) {
                    /* 更新选中节点信息 */
                    let checkList = this.selectKeysMap.get(keyWord);
                    /* 父子关联属性处理 */
                    if (!this.currentCheckStrictly) {
                        //父子关联--删除所属子节点的id数组
                        if (!this.$util.isEmpty(checkList)) {
                            this.selectKeysMap.delete(keyWord);
                            this.clearSeleckKeys(checkList);
                        }
                        if (!this.$util.isEmpty(superiorParentId)) {
                            /* 将父节点数据同步删除 */
                            let keys = this.selectKeysMap.get(superiorParentId);
                            if (!this.$util.isEmpty(keys)) {
                                for (let i in keys) {
                                    if (parentId === keys[i]) {
                                        keys.splice(i, 1);
                                        i--;
                                    }
                                }
                                if (keys.length === 0) {
                                    this.selectKeysMap.delete(superiorParentId);
                                } else {
                                    this.selectKeysMap.set(superiorParentId, keys);
                                }
                            }
                            /* 添加父节点---取消选中的节点数据 */
                            let nochecklist = this.treeDataNocheckMap.get(superiorParentId);
                            if (this.$util.isEmpty(nochecklist)) {
                                this.treeDataNocheckMap.set(superiorParentId, [parentId]);
                            } else {
                                if (!this.isContains(parentId, nochecklist)) {
                                    nochecklist.push(parentId);
                                    this.treeDataNocheckMap.set(superiorParentId, nochecklist);
                                }
                            }
                        }
                        /* 删除父节点node节点 */
                        // for (let i = 0; i < this.checkNodeList.length; i++) {
                        //     if (parentId == this.checkNodeList[i][this.defaultProps.id]) {
                        //         this.checkNodeList.splice(i, 1);
                        //         i--;
                        //     }
                        // }
                        this.clearCheckNodeList(parentId);
                        /* 添加取消选中的节点数据 */
                        let nocheckedlist = this.treeDataNocheckMap.get(parentId);
                        if (this.$util.isEmpty(nocheckedlist)) {
                            this.treeDataNocheckMap.set(parentId, [keyWord]);
                        } else {
                            nocheckedlist.push(keyWord);
                            this.treeDataNocheckMap.set(parentId, nocheckedlist);
                        }
                    }
                    //更新节点本身的数据
                    let keys = this.selectKeysMap.get(parentId);
                    if (!this.$util.isEmpty(keys)) {
                        for (let t in keys) {
                            if (keyWord === keys[t]) {
                                keys.splice(t, 1);
                                t--;
                            }
                        }
                        if (keys.length === 0) {
                            this.selectKeysMap.delete(parentId);
                        } else {
                            this.selectKeysMap.set(parentId, keys);
                        }
                    }
                    /* node节点处理 */
                    for (let i = 0; i < this.checkNodeList.length; i++) {
                        if (keyWord == this.checkNodeList[i][this.defaultProps.id]) {
                            this.checkNodeList.splice(i, 1);
                            i--;
                        } else if (!this.currentCheckStrictly) {
                            /* 父子关联情况下将取消的子节点的node节点同步删除 */
                            for (let k in checkList) {
                                if (this.checkNodeList[i][this.defaultProps.id] === checkList[k]) {
                                    this.checkNodeList.splice(i, 1);
                                    i--;
                                    break;
                                }
                            }
                        }
                    }
                }
            } else {
                /* 单选处理 */
                if (this.isSingleCheck) {
                    if (isCheck) {
                        this.$refs.tdTree.setCheckedKeys([keyWord]);
                    }
                }
            }
            /* 回调父组件方法 */
            this.$emit('check', data, treeObj, this.selectKeysMap);
        },
        // 递归清除父节点
        clearCheckNodeList(parentId) {
            for (let i = 0; i < this.checkNodeList.length; i++) {
                if (!this.$util.isEmpty(parentId) && parentId == this.checkNodeList[i][this.defaultProps.id]) {
                    this.checkNodeList.splice(i, 1);
                    i--;
                }
            }
            let parentNode = this.$refs.tdTree.getNode(parentId);
            if (parentNode != null && parentNode.data != null) {
                this.clearCheckNodeList(parentNode.data[this.defaultProps.parentId]);
            }
        },
        /* 递归删除所有子节点 */
        clearSeleckKeys(checkList) {
            for (let i in checkList) {
                let keys = this.selectKeysMap.get(checkList[i]);
                if (this.$util.isArray(keys) && keys.length > 0) {
                    this.selectKeysMap.delete(checkList[i]);
                    for (let i = 0; i < this.checkNodeList.length; i++) {
                        /* 父子关联情况下将取消的子节点的node节点同步删除 */
                        for (let k in keys) {
                            if (this.checkNodeList[i][this.defaultProps.id] === keys[k]) {
                                this.checkNodeList.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                    this.clearSeleckKeys(keys);
                }
            }
        },
        /* 格式化树形数据 */
        formtTree(ver) {
            for (let i in ver) {
                if (ver[i][this.defaultProps.children]) {
                    if (ver[i][this.defaultProps.children].length <= 0) {
                        ver[i][this.defaultProps.children] = [{}];
                    }
                }
            }
        },
        /* 树形节点添加、修改、删除 */
        editTreeNode(operateData, operation, value) {
            if (this.pageSizeControlMap.size > 0) {
                this.pageSizeControlMap.delete(operateData[0].parentId);
            }
            if (operation === 'delete') {
                this.delete(operateData, value);
                return;
            }
            if (this.lazyloading) {
                this.edit(operateData, this.lazyTreeData, operation, value);
            } else {
                this.edit(operateData, this.treeList, operation, value);
            }
        },
        /* 删除逻辑 */
        delete(operateData, value) {
            for (let item in operateData) {
                let node = this.$refs.tdTree.getNode(operateData[item].id);
                if (node != undefined && node != null) {
                    this.$refs.tdTree.remove(node);
                }
            }
            if (this.lazyloading && operateData.length > 0) {
                this.isLoadData = false;
                this.currentPageMap.set(operateData[0].parentId, 2);
                let pNode = this.$refs.tdTree.getNode(operateData[0].parentId);
                if (pNode != null && pNode != undefined) {
                    this.treeData = pNode.data;
                    this.clearDeleteExpandStatus(pNode.data[this.defaultProps.children]);
                    this.isDownwardLoadingMap.set(operateData[0].parentId, true);
                    let params = this.getParams();
                    params.parentId = operateData[0].parentId;
                    this.queryData(params);
                }
            }
        },
        /* 非懒加载与懒加载非分页模式对树节点的添加、修改、删除 */
        edit(operateData, treeList, operation, value) {
            for (let i = 0; i < treeList.length; i++) {
                let data = treeList[i];
                let children = data[this.defaultProps.children];
                for (let l = 0; l < operateData.length; l++) {
                    if (this.filterText !== '') {
                        if (operateData[l].parentId === data.parentId && operateData[l].id === data[this.defaultProps.id]) {
                            if (operation === 'modify') {
                                data[this.defaultProps.label] = value;
                                operateData.splice(l, 1);
                                l--;
                            }
                        }
                    } else {
                        let parentId = operateData[l].parentId;
                        if (this.$util.isEmpty(parentId)) {
                            if (this.$util.isEmpty(operateData[l].id)) {
                                treeList.push(value);
                                return;
                            }
                            if (data[this.defaultProps.id] === operateData[l].id) {
                                if (operation === 'modify') {
                                    data[this.defaultProps.label] = value;
                                    operateData.splice(l, 1);
                                    l--;
                                } else if (operation === 'add') {
                                    if (data[this.defaultProps.children] !== undefined) {
                                        data[this.defaultProps.children].push(value);
                                    } else {
                                        let children = [];
                                        children.push(value);
                                        this.$set(data, [this.defaultProps.children], children);
                                    }
                                    operateData.splice(l, 1);
                                    l--;
                                }
                            }
                        } else if (parentId === data[this.defaultProps.id]) {
                            let id = operateData[l].id;
                            for (let n in children) {
                                if (id === children[n][this.defaultProps.id]) {
                                    if (operation === 'modify') {
                                        children[n][this.defaultProps.label] = value;
                                        return;
                                    } else if (operation === 'add') {
                                        let addData = children[n];
                                        if (addData[this.defaultProps.children] !== undefined) {
                                            addData[this.defaultProps.children].push(value);
                                        } else {
                                            let children = [];
                                            children.push(value);
                                            this.$set(addData, [this.defaultProps.children], children);
                                        }
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    if (operateData.length > 0 && !this.$util.isEmpty(children) && children.length > 0) {
                        this.edit(operateData, children, operation, value);
                    }
                }
            }
        },
        /* 复选框单选功能功能逻辑 */
        checkChange(data, isCheck) {
            /* 处理回显时未获取到对象的情况 */
            if (this.$util.isEmpty(data)) {
                return;
            }
            // alert();
            // if (isCheck) {
            //     this.setChecked(data[this.defaultProps.id], false);
            // }
            // return;
            if (this.lazyloading) {
                let parentId = '';
                let superiorParentId = '';
                let keyWord = data[this.defaultProps.id];
                if (this.currentCheckStrictly) {
                    parentId = 'currentCheckStrictly';
                } else {
                    parentId = data[this.defaultProps.parentId];
                    if (this.$util.isEmpty(parentId)) {
                        parentId = keyWord;
                    }
                    /* 父节点的父节点id */
                    let parentNode = this.$refs.tdTree.getNode(parentId);
                    if (parentNode !== null) {
                        superiorParentId = parentNode.data[this.defaultProps.parentId];
                    }
                    if (this.$util.isEmpty(keyWord) || this.$util.isEmpty(parentId)) {
                        return;
                    }
                }
                if (isCheck) {
                    /* 添加选中节点的id信息 */
                    let keys = this.selectKeysMap.get(parentId);
                    if (this.$util.isEmpty(keys)) {
                        this.selectKeysMap.set(parentId, [keyWord]);
                    } else {
                        let contains = this.isContains(keyWord, keys);
                        if (!contains) {
                            keys.push(keyWord);
                            this.selectKeysMap.set(parentId, keys);
                        }
                    }
                    if (!this.currentCheckStrictly) {
                        /* 将选中的节点的信息删除掉 */
                        let nochecklist = this.treeDataNocheckMap.get(parentId);
                        if (!this.$util.isEmpty(nochecklist)) {
                            for (let i = 0; i < nochecklist.length; i++) {
                                if (data[this.defaultProps.id] === nochecklist[i]) {
                                    nochecklist.splice(i, 1);
                                    i--;
                                }
                            }
                            if (nochecklist.length === 0) {
                                this.treeDataNocheckMap.delete(parentId);
                                let node = this.$refs.tdTree.getNode(parentId + 'placeholder');
                                if (node != undefined && node != null) {
                                    node.setChecked(true);
                                    this.$refs.tdTree.remove(node);
                                }
                            } else {
                                this.treeDataNocheckMap.set(parentId, nochecklist);
                            }
                        }
                    }
                    /* node节点处理 */
                    if (this.isSingleCheck) {
                        this.checkNodeList = [data];
                    } else {
                        this.checkNodeList.push(data);
                    }
                    /* 父子关联--同步处理子节点信息 */
                    if (!this.currentCheckStrictly && !this.$util.isEmpty(superiorParentId)) {
                        /* 父节点同步选中的情况处理 */
                        let checked = this.$refs.tdTree.getNode(parentId).checked;
                        if (checked) {
                            let keys = this.selectKeysMap.get(superiorParentId);
                            if (this.$util.isEmpty(keys)) {
                                this.selectKeysMap.set(superiorParentId, [parentId]);
                            } else {
                                if (!this.isContains(parentId, keys)) {
                                    keys.push(parentId);
                                    this.selectKeysMap.set(superiorParentId, keys);
                                }
                            }
                            /* 将选中的节点的信息删除掉 */
                            let nochecklist = this.treeDataNocheckMap.get(superiorParentId);
                            if (!this.$util.isEmpty(nochecklist)) {
                                for (let i = 0; i < nochecklist.length; i++) {
                                    if (parentId === nochecklist[i]) {
                                        nochecklist.splice(i, 1);
                                        i--;
                                    }
                                }
                                if (nochecklist.length === 0) {
                                    this.treeDataNocheckMap.delete(superiorParentId);
                                    let node = this.$refs.tdTree.getNode(superiorParentId + 'placeholder');
                                    if (node != undefined && node != null) {
                                        node.setChecked(true);
                                        this.$refs.tdTree.remove(node);
                                    }
                                } else {
                                    this.treeDataNocheckMap.set(superiorParentId, nochecklist);
                                }
                            }
                        }
                    }
                }
            }
            this.$emit('checkChange', data, isCheck);
        },
        /* 获取UUID */
        getUUID() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
</script>
<style>
.custom-tree-node {
    display: inline;
}
.conshow .el-tree-node__label {
    padding: 0px 0px 0px 25px;
    color: #000;
    margin-left: 0.1em;
    font-size: 14px;
}
.conshow {
    overflow-x: auto;
    overflow-y: auto;
    margin-top: 5px;
    margin-left: 10px;
}
.test-1::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.test-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #909399;
}
.test-1::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ffffff;
}
.conshow .el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
}
.el-tree-node__content > div {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.el-tree-node__content {
    min-width: 200px;
}
.span-ellipsis {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.menu__item {
    text-align: center;
    cursor: pointer;
    height: 25px;
}
.tree-header {
    padding-top: 15px;
    opacity: 0;
}
</style>
